import { ISearchListColumn } from 'component/Search/types';
import { map } from 'lodash';
import { columnDefaultRender } from './defaultRender';

/**
 * Takes in a columnset and a single row, and applies each column's rendering function.
 * Returns an array of cell values representing a single row.
 */
export const applyColumnRenderFunction = (
  item: any,
  columns: ISearchListColumn[] | undefined
): (import('exceljs').CellValue | any[])[] =>
  map(columns, column => columnDefaultRender(item, column));
